import MobileSearchCard from "./MobileSearchCard";

export default function MobileHero() {
  return (
    <section className="hv-mobile-home-hero">
      <div className="hv-mobile-home-hero-media">
        <img
          src="/landing/original/featured-card-3.jpg"
          alt=""
          loading="eager"
          decoding="async"
        />
        <div className="hv-mobile-home-hero-copy">
          <span>World's best holiday villas</span>
          <h1>Stay in Places That Stay with You</h1>
          <p>Private villas, boutique homes and seamless journeys curated for families, couples and celebrations.</p>
        </div>
      </div>
      <div className="hv-mobile-home-hero-search">
        <MobileSearchCard compact />
      </div>
    </section>
  );
}
